import workspace from "./workspace";
import { getFilteredWorkspaceData } from "@/utils/workspaceOrgFilter";
import { useStore } from "@/store";


export const getConfigs = async () => {

  const userOrg = useStore.userOrg();
  const params = { org_name: userOrg };

  try {
    return getFilteredWorkspaceData('/config/', 'organization', { params });
  } catch (error) {
    console.error("Error fetching config/s:", error);
    throw error;
  }
};


export const getApplicableConfigs = async ({ org, operating_system, agent = null, group = null, spaceType = null }) => {
  try {
    const params = { organization: org, operating_system };
    if (agent) params.agent = agent;
    if (group) params.group = group;
    if (spaceType) params.space_type = spaceType;
    const response = await workspace.get('/config/get-applicable-configs/', { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching applicable configs:", error);
    throw error;
  }
};


export const getConfigsById = async (id) => {
  try {
    const response = await workspace.get(`/config/${id}/`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching config/ with ID ${id}:`, error);
    throw error;
  }
};


export const createConfig = async (configData) => {
  try {
    const response = await workspace.post(`/config/`, configData,{
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error creating config:", error);
    throw error;
  }
};


export const updateConfig = async (id, configData) => {
  try {
    const response = await workspace.put(`/config/${id}/`, configData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    console.error(`Error updating config with ID ${id}:`, error);
    throw error;
  }
};


export const deleteConfig = async (id) => {
  try {
    const response = await workspace.delete(`/config/${id}/`);
    return response.data;
  } catch (error) {
    console.error(`Error deleting config with ID ${id}:`, error);
    throw error;
  }
};


export const validateConfig = async (file) => {
  try {
    const formData = new FormData();
    formData.append('file', file);
    
    const response = await workspace.post(`/validate/validate_config/`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error validating config:', error);
    throw error;
  }
};
